/**
 * Undo/Redo Actions
 * Pure functions - מחזירים Redux actions
 */

export const undo = () => ({
    type: 'UNDO'
});

export const redo = () => ({
    type: 'REDO'
});

export const clearHistory = () => ({
    type: 'CLEAR_HISTORY'
});
